import { useQuery } from '@tanstack/react-query';
import { getCustomSurveyTemplateTrends } from '../../api/customSurveys';

export enum GetCustomSurveyTemplateTrendsCacheKey {
  CustomSurveyTemplateTrends = 'customSurveyTemplateTrends',
}

export const useGetCustomSurveyTemplateTrendsQuery = (
  templateId: number,
  teamId: number | undefined,
) => {
  return useQuery({
    queryKey: [
      GetCustomSurveyTemplateTrendsCacheKey.CustomSurveyTemplateTrends,
      templateId,
      teamId,
    ],
    queryFn: () => getCustomSurveyTemplateTrends(templateId, teamId!),
    enabled: Boolean(templateId) && Boolean(teamId),
  });
};
